import { render, staticRenderFns } from "./status-badge.vue?vue&type=template&id=4ca5a666&scoped=true"
import script from "./status-badge.vue?vue&type=script&lang=js"
export * from "./status-badge.vue?vue&type=script&lang=js"
import style0 from "./status-badge.vue?vue&type=style&index=0&id=4ca5a666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5a666",
  null
  
)

export default component.exports